import angular from 'angular';
import icToastService from './ic-toast.service';

export default angular.module('admin.templates.common', [])
.service('icToastService', icToastService)


